import { Box, Typography } from "@mui/material";
import React from "react";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import isBetween from "dayjs/plugin/isBetween";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(isBetween);
dayjs.extend(advancedFormat);

const DateField = ({
  title,
  name,
  purchaseDate,
  lastServiceDate,
  handleChange,
  value,
  errors,
  disable,
  noMaxDate,
  width,
  minToday,
}) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <input
        type="date"
        name={name}
        value={value ? new Date(value).toISOString().split("T")[0] : ""}
        // onChange={(e) => {
        //   const newValue = e.target.value;
        //   const todayStr = new Date().toISOString().split("T")[0];
        //   if (newValue && newValue > todayStr) {
        //     handleChange({ name, value: null });
        //   } else {
        //     handleChange({ name, value: newValue });
        //   }
        // }}
        onChange={(e) => {
          handleChange({ name, value: e.target.value });
        }}
        disabled={disable}
        max={noMaxDate ? undefined : new Date().toISOString().split("T")[0]}
        min={
          minToday
            ? new Date().toISOString().split("T")[0]
            : name === "lastServiceDate" && purchaseDate
            ? new Date(purchaseDate).toISOString().split("T")[0]
            : ""
        }
        onFocus={(e) => {
          e.target.style.border = "2px solid #418eda";
          e.target.style.paddingLeft = "9px";
          e.target.style.paddingRight = "9px";
        }}
        onBlur={(e) => {
          e.target.style.border = "1px solid #B8B8B8";
          e.target.style.padding = "10px";
        }}
        style={{
          width: width || "100%",
          height: "40px",
          padding: "10px",
          backgroundColor: "#EDEDED",
          border: "1px solid #B8B8B8",
          borderRadius: "5px",
          outline: "none",
        }}
      />

      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default DateField;
